module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "properties"
  }, [(_vm.issetData()) ? _c('div', {
    staticClass: "md-layout md-gutter"
  }, _vm._l((_vm.propertyValues), function(property, key) {
    return _c('div', {
      key: property.id,
      staticClass: "input-field md-layout-item",
      class: 'property-item ' + property.class + ' md-size-' + property.size
    }, [(property['multiply'] != 1 && !(['checkbox', 'radio', 'select', 'file'].indexOf(property['field_type']) + 1)) ? _c('md-field', {
      class: (property['valid']) ? '' : 'md-invalid'
    }, [(!property.require) ? _c('label', {
      attrs: {
        "for": ('property-' + property.code)
      }
    }, [_vm._v(_vm._s(property.name))]) : _vm._e(), (property.require) ? _c('label', {
      attrs: {
        "for": ('property-' + property.code)
      }
    }, [_vm._v(_vm._s(property.name + ' *'))]) : _vm._e(), ((property["field_type"] === "text")) ? _c('md-input', {
      attrs: {
        "disabled": _vm.$props.disabled,
        "name": property.code,
        "id": 'property-' + property.code
      },
      on: {
        "input": function($event) {
          _vm.FieldChange(property.code)
        }
      },
      model: {
        value: (property['value']),
        callback: function($$v) {
          _vm.$set(property, 'value', $$v)
        },
        expression: "property['value']"
      }
    }) : _vm._e(), ((property["field_type"] === "number")) ? _c('md-input', {
      attrs: {
        "disabled": _vm.$props.disabled,
        "name": property.code,
        "id": 'property-' + property.code,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.FieldChange(property.code)
        }
      },
      model: {
        value: (property['value']),
        callback: function($$v) {
          _vm.$set(property, 'value', $$v)
        },
        expression: "property['value']"
      }
    }) : _vm._e(), ((property["field_type"] === "textarea")) ? _c('md-textarea', {
      attrs: {
        "disabled": _vm.$props.disabled,
        "name": property.code,
        "id": 'property-' + property.code
      },
      on: {
        "input": function($event) {
          _vm.FieldChange(property.code)
        }
      },
      model: {
        value: (property['value']),
        callback: function($$v) {
          _vm.$set(property, 'value', $$v)
        },
        expression: "property['value']"
      }
    }) : _vm._e(), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!property['valid']),
        expression: "!property['valid']"
      }],
      staticClass: "md-error"
    }, [_vm._v("Проверьте корректность вводимых данныx")])], 1) : _vm._e(), _vm._l((property['value']), function(value, i) {
      return (property['multiply'] == '1' && !(['checkbox', 'radio', 'select', 'file'].indexOf(property['field_type']) + 1)) ? _c('div', [_c('md-field', {
        class: (property['valid'][i] ? '' : 'md-invalid')
      }, [_c('label', [_vm._v(_vm._s(property.name + ' ' + (i + 1)))]), ((property["field_type"] === "text")) ? _c('md-input', {
        attrs: {
          "disabled": _vm.$props.disabled,
          "name": property.code,
          "id": 'property-' + property.code + '-' + (i + 1)
        },
        on: {
          "input": function($event) {
            _vm.FieldChange(property.code)
          }
        },
        model: {
          value: (property['value'][i]),
          callback: function($$v) {
            _vm.$set(property['value'], i, $$v)
          },
          expression: "property['value'][i]"
        }
      }) : _vm._e(), ((property["field_type"] === "number")) ? _c('md-input', {
        attrs: {
          "disabled": _vm.$props.disabled,
          "name": property.code,
          "id": 'property-' + property.code + '-' + (i + 1),
          "type": "number"
        },
        on: {
          "input": function($event) {
            _vm.FieldChange(property.code)
          }
        },
        model: {
          value: (property['value'][i]),
          callback: function($$v) {
            _vm.$set(property['value'], i, $$v)
          },
          expression: "property['value'][i]"
        }
      }) : _vm._e(), ((property["field_type"] === "textarea")) ? _c('md-textarea', {
        attrs: {
          "disabled": _vm.$props.disabled,
          "name": property.code,
          "id": 'property-' + property.code + '-' + (i + 1)
        },
        on: {
          "input": function($event) {
            _vm.FieldChange(property.code)
          }
        },
        model: {
          value: (property['value'][i]),
          callback: function($$v) {
            _vm.$set(property['value'], i, $$v)
          },
          expression: "property['value'][i]"
        }
      }) : _vm._e(), (i > 0) ? _c('md-button', {
        staticClass: "md-icon-button md-dense",
        on: {
          "click": function($event) {
            property['value'].splice(i, 1);
            property['valid'].splice(i, 1);
            property['changed'] = 1;
          }
        }
      }, [_c('md-icon', [_vm._v("close")])], 1) : _vm._e(), _c('md-button', {
        staticClass: "md-icon-button md-dense",
        on: {
          "click": function($event) {
            property['value'].push(null);
            property['valid'].push(1);
            property['changed'] = 1;
          }
        }
      }, [_c('md-icon', [_vm._v("add")])], 1), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!property['valid']),
          expression: "!property['valid']"
        }],
        staticClass: "md-error"
      }, [_vm._v("Проверьте корректность вводимых данныx")])], 1)], 1) : _vm._e()
    }), (property['field_type'] === 'radio' && property.choices.length > 1) ? _c('div', [_c('label', [_vm._v(_vm._s(property.name))]), _vm._l((property.choices), function(choices, i) {
      return _c('div', [_c('z-check', {
        attrs: {
          "label": choices.name,
          "id": ('service-' + choices.code),
          "value": choices.code,
          "disabled": _vm.$props.disabled
        },
        model: {
          value: (property['value']),
          callback: function($$v) {
            _vm.$set(property, 'value', $$v)
          },
          expression: "property['value']"
        }
      })], 1)
    })], 2) : _vm._e(), (property['field_type'] === 'select' && property.choices.length > 1) ? _c('div', [_c('md-field', [_c('label', [_vm._v(_vm._s(property.name))]), _c('md-select', {
      attrs: {
        "disabled": _vm.$props.disabled,
        "name": property.code,
        "id": 'property-' + property.code
      },
      on: {
        "click": function($event) {
          _vm.FieldChange(property.code)
        }
      },
      model: {
        value: (property['value']),
        callback: function($$v) {
          _vm.$set(property, 'value', $$v)
        },
        expression: "property['value']"
      }
    }, _vm._l((property.choices), function(choices, i) {
      return _c('md-option', {
        key: i,
        attrs: {
          "value": choices.code
        }
      }, [_vm._v(_vm._s(choices.name))])
    }))], 1)], 1) : _vm._e(), (property['field_type'] === 'checkbox') ? _c('div', [((property.choices.length > 1)) ? _c('label', [_vm._v(_vm._s(property.name))]) : _vm._e(), _vm._l((property.choices), function(choices) {
      return _c('div', [((property.choices.length == 1)) ? _c('md-switch', {
        attrs: {
          "disabled": _vm.$props.disabled,
          "value": choices.code
        },
        on: {
          "change": function($event) {
            _vm.FieldChange(property.code)
          }
        },
        model: {
          value: (property['value']),
          callback: function($$v) {
            _vm.$set(property, 'value', $$v)
          },
          expression: "property['value']"
        }
      }, [_vm._v(_vm._s(property.name))]) : _vm._e(), ((property.choices.length > 1)) ? _c('md-checkbox', {
        attrs: {
          "disabled": _vm.$props.disabled,
          "value": choices.code
        },
        on: {
          "change": function($event) {
            _vm.FieldChange(property.code)
          }
        },
        model: {
          value: (property['value']),
          callback: function($$v) {
            _vm.$set(property, 'value', $$v)
          },
          expression: "property['value']"
        }
      }, [_vm._v(_vm._s(choices.name))]) : _vm._e()], 1)
    })], 2) : _vm._e(), (property['field_type'] === 'file') ? _c('div', [_c('div', {
      staticClass: "file-container"
    }, [_c('div', {
      staticClass: "md-layout-item"
    }, [_c('md-field', [_c('label', [_vm._v(_vm._s(property.name))]), ((property.multiply != '1')) ? _c('md-file', {
      attrs: {
        "disabled": _vm.$props.disabled,
        "name": property.code,
        "id": 'property-' + property.code
      },
      on: {
        "change": _vm.changeFile
      },
      model: {
        value: (property['value']),
        callback: function($$v) {
          _vm.$set(property, 'value', $$v)
        },
        expression: "property['value']"
      }
    }) : _vm._e(), ((property.multiply == '1')) ? _c('md-file', {
      attrs: {
        "disabled": _vm.$props.disabled,
        "name": property.code,
        "id": 'property-' + property.code,
        "multiple": "multiple"
      },
      on: {
        "change": _vm.changeFile
      },
      model: {
        value: (property['value']),
        callback: function($$v) {
          _vm.$set(property, 'value', $$v)
        },
        expression: "property['value']"
      }
    }) : _vm._e()], 1)], 1), (Object.keys(_vm.files).length && Object.keys(_vm.files[property.code]).length) ? _c('div', {
      staticClass: "md-flex file-card-container"
    }, _vm._l((_vm.files[property.code]), function(file) {
      return _c('md-card', {
        key: file.id,
        staticClass: "image-container"
      }, [(file.image) ? _c('md-card-media', {
        attrs: {
          "md-ratio": "16:9"
        }
      }, [_c('img', {
        attrs: {
          "src": file.path
        }
      })]) : _vm._e(), _c('md-card-area', [_c('md-card-header', [_c('div', {
        staticClass: "md-title"
      }, [_vm._v(_vm._s(file.name))]), _c('span', {
        staticClass: "md-subhead"
      }, [_vm._v(_vm._s(file.size))]), _c('span', {
        staticClass: "md-subhead"
      }, [_vm._v(_vm._s(', Формат: ' + file.file_type))]), (file && file['uploader']) ? _c('div', {
        staticClass: "md-subhead"
      }, [_vm._v(_vm._s('Загрузил: ' + file['uploader']['login'] + ' (' + _vm.moment(file['created_at']).format('DD.MM.YYYY HH:mm:ss') + ')'))]) : _vm._e()]), _c('md-card-actions', [_c('span', [_c('md-button', {
        staticClass: "md-icon-button md-dense",
        on: {
          "click": function($event) {
            _vm.openFile(file.path)
          }
        }
      }, [_c('md-icon', [_vm._v("loupe")])], 1), _c('md-tooltip', {
        attrs: {
          "md-direction": "top",
          "md-delay": "300"
        }
      }, [_vm._v(_vm._s(_vm.openFileTooltip))])], 1), _c('span', [_c('md-button', {
        staticClass: "md-icon-button md-dense",
        on: {
          "click": function($event) {
            _vm.removeFile(property, file['id'])
          }
        }
      }, [_c('md-icon', [_vm._v("close")])], 1), _c('md-tooltip', {
        attrs: {
          "md-direction": "top",
          "md-delay": "300"
        }
      }, [_vm._v(_vm._s(_vm.deleteFileTooltip))])], 1)])], 1)], 1)
    })) : _vm._e()])]) : _vm._e()], 2)
  })) : _vm._e(), (!_vm.issetData()) ? _c('div', [_c('span', [_vm._v("Не указан один из обязательных параметров компонента либо не верен его формат")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2a5a516","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Properties.vue
// module id = 1262
// module chunks = 0